import { ExternalLink } from 'lucide-react'
import { config } from '../config/environment'

export default function CompetitionResultsCard() {
  const url = config.competitionResultsUrl

  if (!url) {
    return null
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Competition Results</h3>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-4 py-2 bg-fwo-blue text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        View Competition Results
        <ExternalLink className="h-4 w-4" />
      </a>
    </div>
  )
}
